<template>
  <div class="app-container">
    <!-- 筛选区域 -->
    <div class="filter-area">
      <el-form :model="searchForm" class="filter-form" label-width="70px">
        <el-form-item label="搜索">
          <el-input
            v-model="searchForm.keyword"
            placeholder="员工/客户/电话"
            clearable
            style="width: 100px"
            @keyup.enter="fetchDaodianList"
          />
        </el-form-item>

        <el-form-item label="到店类型">
          <el-select
            v-model="searchForm.leixingId"
            placeholder="选择"
            clearable
            style="width: 100px"
          >
            <el-option
              v-for="item in leixingList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="意向度">
          <el-select
            v-model="searchForm.yixiangdu"
            placeholder="选择"
            clearable
            style="width: 100px"
          >
            <el-option label="高" value="A" />
            <el-option label="中" value="B" />
            <el-option label="低" value="C" />
          </el-select>
        </el-form-item>

        <el-form-item label="跟进时间">
          <el-select
            v-model="searchForm.followTime"
            placeholder="选择"
            clearable
            style="width: 100px"
            @change="fetchDaodianList"
          >
            <el-option label="7天内更新" value="within7" />
            <el-option label="超过7天未更新" value="over7" />
            <el-option label="超过15天未更新" value="over15" />
          </el-select>
        </el-form-item>

        <el-form-item label="到店时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            style="width: 250px"
            @change="handleDateRangeChange"
            @clear="handleDateClear"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="fetchDaodianList" size="mini">
            查询
          </el-button>
          <el-button @click="resetSearch" size="mini">
            重置
          </el-button>
          <el-button type="success" @click="openAddDaodianPage" size="mini">
            新增
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据总数 + 加载状态 -->
    <div class="info-bar">
      <div class="total-count" v-if="total > 0">
        共 {{ total }} 条数据
      </div>
      <div class="loading" v-if="isLoading">
        <el-skeleton active /> 加载中...
      </div>
    </div>

    <!-- 卡片式数据列表 -->
    <div class="card-list">
      <div class="no-data" v-if="!isLoading && daodianList.length === 0">
        暂无符合条件的数据
      </div>

      <div
        v-for="(item, index) in daodianList"
        :key="item.id"
        class="data-card"
        @click="toFollowRecord(item.id)"
      >
        <div class="card-header">
          <div class="to-store-type">
            {{ item.leixing?.name || '未知类型' }}
          </div>
        </div>

        <div class="card-body">
          <div class="info-row primary-info">
            <div class="customer-name">{{ item.name || '-' }}</div>
            <div class="age">{{ item.age ? item.age + '岁' : '-' }}</div>
            <span
              class="intention-tag"
              :class="{
                'high': item.yixiangdu === 'A',
                'middle': item.yixiangdu === 'B',
                'low': item.yixiangdu === 'C'
              }"
            >
              {{ item.yixiangdu === 'A' ? '高意向' : item.yixiangdu === 'B' ? '中意向' : '低意向' }}
            </span>
          </div>

          <div class="info-row secondary-info">
            <i class="el-icon-phone-outline contact-icon"></i>
            <span class="contact-value">{{ item.phone || '-' }}</span>
          </div>

          <div class="info-row tertiary-info">
            <div class="update-time">
              <i class="el-icon-time time-icon"></i>
              <span>{{ formatDate(item.update_time) || '无记录' }}</span>
            </div>
            <el-button
              type="primary"
              class="detail-btn"
              size="mini"
            >
              查看详情
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页组件 -->
    <el-pagination
      v-if="total > 0"
      v-model:current-page="pagination.currentPage"
      v-model:page-size="pagination.pageSize"
      :page-sizes="[10, 20, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total"
      @size-change="handlePageSizeChange"
      @current-change="handlePageChange"
      class="mobile-pagination"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from 'axios';
import request from "@/util/request";
import { ElMessage } from "element-plus";
import { ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElDatePicker, ElButton, ElSkeleton, ElPagination } from "element-plus";

export default {
  name: "DaodianMobile",
  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElButton,
    ElSkeleton,
    ElPagination
  },
  setup() {
    const router = useRouter();

    // 数据与筛选
    const daodianList = ref([]);
    const leixingList = ref([]);
    const searchForm = ref({
      keyword: "",
      leixingId: "",
      yixiangdu: "",
      followTime: "",
    });
    const dateRange = ref([]);

    // 分页与状态
    const pagination = ref({ currentPage: 1, pageSize: 10, total: 0 });
    const total = ref(0);
    const isLoading = ref(false);

    // 日期格式化
    const formatDate = (time) => {
      if (!time) return '';
      try {
        const date = new Date(time);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
      } catch (err) {
        return time.slice(0, 16);
      }
    };

    // 日期范围变化（重置页码+请求）
    const handleDateRangeChange = () => {
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    // 日期清除专用逻辑
    const handleDateClear = () => {
      dateRange.value = [];
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    // 获取数据列表
    const fetchDaodianList = async () => {
      if (isLoading.value) return;
      isLoading.value = true;
      try {
        const queryParams = {
          pagenum: pagination.value.currentPage,
          pagesize: pagination.value.pageSize,
          keyword: searchForm.value.keyword.trim(),
          leixing_id: searchForm.value.leixingId || "",
          yixiangdu: searchForm.value.yixiangdu || "",
          follow_time: searchForm.value.followTime || "",
          start_date: dateRange.value[0] || "",
          end_date: dateRange.value[1] || ""
        };

        const res = await request.get("api/daodian/", queryParams);
        if (res.data && typeof res.data === 'object') {
          if (res.data.code === 200) {
            daodianList.value = res.data.data || [];
            total.value = res.data.total || 0;
            pagination.value.total = total.value;
          } else {
            ElMessage.error(res.data.errorInfo || "数据获取失败");
          }
        } else {
          ElMessage.error("接口响应异常");
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          ElMessage.error("网络异常，获取数据失败");
        }
      } finally {
        isLoading.value = false;
      }
    };

    // 分页事件处理
    const handlePageSizeChange = (pageSize) => {
      pagination.value.pageSize = pageSize;
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    const handlePageChange = (currentPage) => {
      pagination.value.currentPage = currentPage;
      fetchDaodianList();
    };

    // 获取到店类型列表
    const getLeixingList = async () => {
      try {
        const res = await request.get("api/leixing/");
        if (res.data && typeof res.data === 'object' && res.data.code === 200) {
          leixingList.value = res.data.data || [];
        } else {
          ElMessage.error(res.data?.errorInfo || "获取类型失败");
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          ElMessage.error("网络异常，获取类型失败");
        }
      }
    };

    // 重置搜索条件
    const resetSearch = () => {
      searchForm.value = {
        keyword: "",
        leixingId: "",
        yixiangdu: "",
        followTime: "",
      };
      dateRange.value = [];
      pagination.value.currentPage = 1;
      fetchDaodianList();
    };

    // 页面跳转
    const openAddDaodianPage = () => {
      router.push("/mobile/daodian/add");
    };

    const toFollowRecord = (daodianId) => {
      router.push({
        path: "/mobile/daodian/follow",
        query: { daodianId }
      });
    };

    // 初始化加载
    onMounted(() => {
      fetchDaodianList();
      getLeixingList();
    });

    return {
      daodianList,
      leixingList,
      searchForm,
      pagination,
      total,
      isLoading,
      dateRange,
      formatDate,
      fetchDaodianList,
      handlePageSizeChange,
      handlePageChange,
      getLeixingList,
      resetSearch,
      openAddDaodianPage,
      toFollowRecord,
      handleDateRangeChange,
      handleDateClear,
    };
  },
};
</script>

<style scoped>
.app-container {
  padding: 10px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.filter-area {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 5px;
}

.total-count {
  color: #606266;
  font-size: 14px;
}

.loading {
  color: #409eff;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.data-card {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.2s;
}

.data-card:active {
  transform: scale(0.99);
}

.card-header {
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.to-store-type {
  color: #409eff;
  font-size: 15px;
  font-weight: 500;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.primary-info {
  justify-content: space-between;
}

.customer-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.age {
  color: #606266;
  font-size: 14px;
}

.intention-tag {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  color: #fff;
}

.intention-tag.high {
  background-color: #67c23a;
}

.intention-tag.middle {
  background-color: #e6a23c;
}

.intention-tag.low {
  background-color: #f56c6c;
}

.secondary-info {
  color: #606266;
  font-size: 14px;
  gap: 5px;
}

.tertiary-info {
  justify-content: space-between;
  color: #909399;
  font-size: 13px;
}

.contact-icon, .time-icon {
  font-size: 14px;
}

.detail-btn {
  padding: 4px 10px;
}

.no-data {
  text-align: center;
  padding: 30px 0;
  color: #909399;
  background: #fff;
  border-radius: 8px;
}

.mobile-pagination {
  margin-top: 20px;
  text-align: center;
  padding: 10px;
}
</style>